import { lazy, Suspense } from 'react'
import { Box } from '@chakra-ui/react'
import { Seo } from '../components/Seo'
import { buildFaqPageJsonLd } from '../components/Seo.helpers'
import { DeferredSection } from '../components/DeferredSection'
import { HeroSection } from './landing/HeroSection'
import { WhatIsThisSection } from './landing/WhatIsThisSection'
import { FaqSection } from './landing/FaqSection'
import { FinalCtaSection } from './landing/FinalCtaSection'
import { FAQ_ITEMS } from './landing/faq-data'

// The heavy, below-the-fold sections are code-split and deferred until the user
// scrolls near them: HowItWorks pulls the uPlot decay graph, WhySacrifice pulls
// framer-motion, LiveStats fires a directory-stats request, and SupportedChains
// renders the chain-logo grid. Keeping the hero + "what is this" eager preserves
// a fast, text-based LCP. (Lazy via the named export so the test mocks resolve.)
const HowItWorksSection = lazy(() =>
  import('./landing/HowItWorksSection').then(m => ({ default: m.HowItWorksSection }))
)
const WhySacrificeSection = lazy(() =>
  import('./landing/WhySacrificeSection').then(m => ({ default: m.WhySacrificeSection }))
)
const HistoricalSacrificesSection = lazy(() =>
  import('./landing/HistoricalSacrificesSection').then(m => ({
    default: m.HistoricalSacrificesSection,
  }))
)
const SupportedChainsSection = lazy(() =>
  import('./landing/SupportedChainsSection').then(m => ({ default: m.SupportedChainsSection }))
)

const faqPageJsonLd = buildFaqPageJsonLd(FAQ_ITEMS)

export const Landing = () => (
  <Box>
    <Seo additionalJsonLd={[faqPageJsonLd]} />
    <HeroSection />
    <WhatIsThisSection />
    <DeferredSection minHeight="640px">
      <Suspense fallback={null}>
        <HowItWorksSection />
      </Suspense>
    </DeferredSection>
    <DeferredSection minHeight="560px">
      <Suspense fallback={null}>
        <WhySacrificeSection />
      </Suspense>
    </DeferredSection>
    <DeferredSection minHeight="480px">
      <Suspense fallback={null}>
        <HistoricalSacrificesSection />
      </Suspense>
    </DeferredSection>
    <DeferredSection minHeight="440px">
      <Suspense fallback={null}>
        <SupportedChainsSection />
      </Suspense>
    </DeferredSection>
    <FaqSection />
    <FinalCtaSection />
  </Box>
)

export default Landing
